export default __webpack_public_path__ + "static/media/demo-5-raw.bdbbe0fc.jpg";